var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('n-bread',{attrs:{"content":{bread_list: _vm.bread_list, bread_active: _vm.bread_active}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('n-starred')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }